export default __webpack_public_path__ + "static/301-2c0262a297c768cf4f663c53780c8657.gif";